@file:OptIn(InternalResourceApi::class)

package waifupics.modules.features.random.filter.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/waifupics.modules.features.random.filter.generated.resources/"

@delegate:ResourceContentHash(-1_403_334_444)
internal val Res.string.age_rating: StringResource by lazy {
      StringResource("string:age_rating", "age_rating", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 34),
      ))
    }

@delegate:ResourceContentHash(-71_469_583)
internal val Res.string.borderline: StringResource by lazy {
      StringResource("string:borderline", "borderline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45, 34),
      ))
    }

@delegate:ResourceContentHash(1_507_453_160)
internal val Res.string.done: StringResource by lazy {
      StringResource("string:done", "done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80, 20),
      ))
    }

@delegate:ResourceContentHash(-1_867_054_547)
internal val Res.string.explicit_18: StringResource by lazy {
      StringResource("string:explicit_18", "explicit_18", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 101, 39),
      ))
    }

@delegate:ResourceContentHash(-1_963_583_832)
internal val Res.string.filter: StringResource by lazy {
      StringResource("string:filter", "filter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141, 22),
      ))
    }

@delegate:ResourceContentHash(-1_656_346_608)
internal val Res.string.report_title: StringResource by lazy {
      StringResource("string:report_title", "report_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164, 28),
      ))
    }

@delegate:ResourceContentHash(-1_582_237_413)
internal val Res.string.safe_for_work: StringResource by lazy {
      StringResource("string:safe_for_work", "safe_for_work", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193, 41),
      ))
    }

@delegate:ResourceContentHash(-1_503_567_278)
internal val Res.string.suggestive: StringResource by lazy {
      StringResource("string:suggestive", "suggestive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235, 34),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("age_rating", Res.string.age_rating)
  map.put("borderline", Res.string.borderline)
  map.put("done", Res.string.done)
  map.put("explicit_18", Res.string.explicit_18)
  map.put("filter", Res.string.filter)
  map.put("report_title", Res.string.report_title)
  map.put("safe_for_work", Res.string.safe_for_work)
  map.put("suggestive", Res.string.suggestive)
}
